module.exports = __webpack_public_path__ + "img/phoneinpocket.98657b33.png";